import _ from 'lodash';
import { connect } from 'react-redux';
import { updateUserProfile } from 'app/common/api/common-api';
import GeneralAccount from 'app/components/settings/general-account';
import { getBasicAccountInfo } from 'app/selectors/user';

const mapStateToProps = state => ({
  initialValues: getBasicAccountInfo(state),
  userSubmitError: _.get(state, 'common.userSubmitError'),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => dispatch(updateUserProfile(values)),
});

const GeneralAccountContainer = connect(mapStateToProps, mapDispatchToProps)(GeneralAccount);

export default GeneralAccountContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/general-account.js